/**
 * 事件中心
 */

export default class EventCenter {
  /**
   * 用来判断是针对帖文的回复还是帖文评论的回复的事件名
   * @returns {string}
   */
  static get replyBoxVisible() {
    return "replyBoxVisible";
  }

  /**
   * 打开AI小助手
   * @description 事件载荷可传字符串或者对象, 对象格式:`{text:string}`, 字符串会填充到输入框内, 需手动发送, 对象格式则自动发送至AI
   * @returns {string}
   * @constructor
   */
  static get PropsParamSuggestByAIReplyComp() {
    return "PropsParamSuggestByAIReplyComp";
  }

  /**
   * 关闭AI助手并清理AI助手的内容
   * @returns {string}
   */
  static get postDetailCancelReply() {
    return "PostDetailCancelReply";
  }

  /**
   * 邮件效果预览事件名
   */
  static get emailPreview() {
    return "emailPreview";
  }

  /**
   * 创建 whatsapp 模板的页面通信频道
   */
  static get whatsappTemplate() {
    return "whatsappTemplate";
  }

  /**
   * 创建标签的页面通信事件
   */
  static get userTag() {
    return "userTag";
  }
  static get refreshEmailList() {
    return "refreshEmailList";
  }

  /**
   * 是否折叠机器人树菜单
   * @description 传 boolean, true 表示折叠
   * @returns {string}
   */
  static get collapseBotTree() {
    return "collapseBotTree";
  }

  /**
   * 是否折叠右侧工具栏
   * @description 传 boolean, true 表示折叠
   * @returns {string}
   */
  static get collapseToolbar() {
    return "collapseToolbar";
  }

  /**
   * JoinMC 场景工具栏具体场景点击
   * @returns {string}
   */
  static get sceneTagClick() {
    return "sceneTagClick";
  }

  /**
   * 展开情形工具
   * @returns {string}
   */
  static get moreScene() {
    return "moreScene";
  }

  /**
   * 更新 BotTree
   * @returns {string}
   */
  static get botTreeRefresh() {
    return "botTreeRefresh";
  }

  /**
   * 获取团队的套餐提醒
   * @readonly
   * @static
   * @memberof EventCenter
   */
  static get getPackageReminder() {
    return "getPackageReminder";
  }

  /**
   * Axios 收到套餐限制响应后，通知根节点打开套餐上限提示弹窗。
   * @returns {string}
   */
  static get openPackageLimitDialog() {
    return "openPackageLimitDialog";
  }

  /**
   * 新建机器人时通知付组件缓存机器人信息表单的事件
   */
  static get cacheCreateBotForm() {
    return "cacheCreateBotForm";
  }

  /**
   * 打开微信公众号弹窗
   */
  static get openWechatQrcodeDialog() {
    return "openWechatQrcodeDialog";
  }

  /**
   * 完成Microsoft365关联的事件
   */
  static get manualBindMicrosoft365() {
    return "manualBindMicrosoft365";
  }

  /**
   * 重新计算消息数量
   */
  static get recountMessageNum() {
    return "recountMessageNum";
  }

  /**
   * BotWorkStationBar 数据表列
   */
  static get localforageBotWorkStationBarColumn() {
    return {
      botWorkStationBarActive: "botWorkStationBarActive",
      asideBarMenuList: "asideBarMenuList"
    };
  }

  /**
   * 舆情 导航栏数据表
   */
  static get localforageNavigationBarColumn() {
    return {
      navigationBarActive: "navigationBarActive",
      asideBarMenuList: "asideBarMenuList"
    };
  }

  /**
   * 内容发布 导航栏数据表
   */
  static get PublisherNavigationBarColumn() {
    return {
      navigationBarActive: "navigationBarActive",
      asideBarMenuList: "asideBarMenuList"
    };
  }

  /**
   * AI助手插入和替换操作后触发该事件
   * @return {string}
   */
  static get DispatchAiSuggestedText() {
    return "dispatchAiSuggestedText";
  }

  /**
   * 打开贴文预览工具栏命令
   * @example eventBus.$emit(EventCenter.ToolBarPostPreviewVisible, 7);
   * @return {string}
   * @constructor
   */
  static get ToolBarPostPreviewVisible() {
    return "toolBarPostPreviewVisible";
  }

  /**
   * 充值事件
   * @returns {string}
   * @constructor
   */
  static get RechargeMessage() {
    return "RechargeMessage";
  }

  /**
   * 打开账号冻结提示
   * @return {string}
   */
  static get openPackageLockedDialog() {
    return "openPackageLockedDialog";
  }

  /**
   * WhatsApp 发送时收到 50001，通知根节点展示团队余额不足弹窗。
   * @returns {string}
   */
  static get openWhatsAppBalanceInsufficientDialog() {
    return "openWhatsAppBalanceInsufficientDialog";
  }

  /**
   * 打开添加团队成员弹窗
   * @description 发送时没有载荷
   * @example eventBus.$emit(EventCenter.openAddTeamMemberDialog)
   * @return {string}
   */
  static get openAddTeamMemberDialog() {
    return "openAddTeamMemberDialog";
  }

  /**
   * 广告账户授权的广播频道
   * @constructor
   */
  static get AdAccountAuthChannel() {
    return {
      name: "AdAccount",
      event: {
        success: "AdAccountSuccess",
        failed: "AdAccountFailed"
      }
    };
  }
}